/* MAGNETO RING — behaviour for Dawn custom sections.
   Uses Shopify Ajax Cart API (/cart/add.js) for real add-to-cart.
   Money: prefers the Liquid-rendered, market-aware string on each variant
   (price_money). Falls back to a formatter that understands all of Shopify's
   money_format placeholders. */
(function(){
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }

  /* ---- money helpers ---- */
  function groupAmount(cents, thousands, decimal, places){
    var n = Number(cents); if(isNaN(n)) n = 0;
    var s = (n/100).toFixed(places);
    var parts = s.split('.');
    var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return places ? intPart + decimal + parts[1] : intPart;
  }
  function formatMoney(cents, format){
    var f = format || '${{amount}}';
    var out;
    if(/amount_no_decimals_with_comma_separator/.test(f))      out = groupAmount(cents, '.', ',', 0);
    else if(/amount_with_comma_separator/.test(f))             out = groupAmount(cents, '.', ',', 2);
    else if(/amount_with_apostrophe_separator/.test(f))        out = groupAmount(cents, "'", '.', 2);
    else if(/amount_no_decimals/.test(f))                      out = groupAmount(cents, ',', '.', 0);
    else                                                       out = groupAmount(cents, ',', '.', 2);
    return f.replace(/\{\{\s*[a-z_]+\s*\}\}/, out);
  }

  ready(function(){
    /* ---- reveal on scroll ---- */
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('mag-in'); io.unobserve(e.target); } });
      },{threshold:.16});
      document.querySelectorAll('.mag-reveal').forEach(function(el){ io.observe(el); });
    } else {
      document.querySelectorAll('.mag-reveal').forEach(function(el){ el.classList.add('mag-in'); });
    }

    /* ---- marquee duplicate for seamless loop ---- */
    var mq=document.getElementById('mag-mq-track');
    if(mq) mq.innerHTML+=mq.innerHTML;

    /* ---- FAQ accordion ---- */
    document.querySelectorAll('.mag-faq__q').forEach(function(q){
      q.addEventListener('click',function(){
        var open=q.getAttribute('aria-expanded')==='true';
        document.querySelectorAll('.mag-faq__q').forEach(function(x){
          x.setAttribute('aria-expanded','false'); x.nextElementSibling.style.maxHeight=null;
        });
        if(!open){ q.setAttribute('aria-expanded','true'); var a=q.nextElementSibling; a.style.maxHeight=a.scrollHeight+'px'; }
      });
    });

    /* ---- purchase block ---- */
    var root=document.querySelector('[data-mag-purchase]');
    if(!root) return;

    var variants   = JSON.parse(root.getAttribute('data-variants')||'[]');
    var moneyFormat= (root.getAttribute('data-money')||'${{amount}}').replace(/<[^>]+>/g,'');
    var current    = variants[0];

    /* Liquid already rendered each variant's price in the visitor's market
       currency, so use that string verbatim whenever it is available. */
    function priceOf(v){
      if(v && v.price_money) return v.price_money;
      return formatMoney(v ? v.price : 0, moneyFormat);
    }

    var mainImg   = root.querySelector('[data-mag-main-img]');
    var priceEl   = document.querySelectorAll('[data-mag-price]');
    var atcPrice  = document.querySelectorAll('[data-mag-atc-price]');
    var atcBtn    = root.querySelector('[data-mag-atc]');
    var qtyInput  = root.querySelector('[data-mag-qty]');
    var colorName = root.querySelector('[data-mag-color-name]');
    var heroImg   = document.querySelector('[data-mag-hero-img]');
    var sbImg     = document.querySelector('[data-mag-sb-img]');

    var labelAdd  = (atcBtn && atcBtn.getAttribute('data-label-add'))  || 'Add to cart';
    var labelSold = (atcBtn && atcBtn.getAttribute('data-label-sold')) || 'Sold out';

    function setPrice(v){
      var s = priceOf(v);
      priceEl.forEach(function(el){ el.textContent=s; });
      atcPrice.forEach(function(el){ el.textContent=s; });
    }
    function selectVariant(v){
      current=v;
      setPrice(v);
      if(colorName) colorName.textContent=v.title;
      if(v.image){
        if(mainImg){ mainImg.style.opacity=0; setTimeout(function(){ mainImg.src=v.image; mainImg.style.opacity=1; },160); }
        if(heroImg) heroImg.src=v.image;
        if(sbImg) sbImg.src=v.image;
      }
      atcBtn.disabled=!v.available;
      atcBtn.querySelector('[data-mag-atc-label]').textContent = v.available ? labelAdd : labelSold;
    }
    setPrice(current);

    /* swatches */
    root.querySelectorAll('[data-mag-swatch]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var id=btn.getAttribute('data-mag-swatch');
        var v=variants.filter(function(x){return String(x.id)===String(id);})[0];
        root.querySelectorAll('[data-mag-swatch]').forEach(function(x){ x.classList.remove('mag-active'); x.setAttribute('aria-checked','false'); });
        btn.classList.add('mag-active'); btn.setAttribute('aria-checked','true');
        if(v) selectVariant(v);
      });
    });

    /* gallery thumbs */
    root.querySelectorAll('[data-mag-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var src=btn.getAttribute('data-mag-thumb');
        if(mainImg){ mainImg.style.opacity=0; setTimeout(function(){ mainImg.src=src; mainImg.style.opacity=1; },160); }
        root.querySelectorAll('[data-mag-thumb]').forEach(function(x){ x.classList.remove('mag-active'); });
        btn.classList.add('mag-active');
      });
    });

    /* quantity */
    function clampQty(v){ v=parseInt(v,10)||1; return Math.min(10,Math.max(1,v)); }
    var qMinus=root.querySelector('[data-mag-qminus]'), qPlus=root.querySelector('[data-mag-qplus]');
    if(qMinus) qMinus.addEventListener('click',function(){ qtyInput.value=clampQty(+qtyInput.value-1); });
    if(qPlus)  qPlus.addEventListener('click',function(){ qtyInput.value=clampQty(+qtyInput.value+1); });
    if(qtyInput) qtyInput.addEventListener('change',function(){ qtyInput.value=clampQty(qtyInput.value); });

    /* ---- real Shopify add to cart (Dawn-aware) ---- */
    var routes = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';

    function addToCart(id, qty){
      atcBtn.disabled=true;
      var drawer=document.querySelector('cart-drawer');
      var body={ items:[{ id:id, quantity:qty }] };
      // If Dawn's drawer is present, ask for its sections so it can re-render
      if(drawer){
        body.sections = ['cart-drawer','cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }
      return fetch(routes+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(body)
      })
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,d:d}; }); })
      .then(function(res){
        atcBtn.disabled=false;
        if(!res.ok){ throw new Error((res.d && res.d.description) || 'Add to cart failed'); }
        if(drawer && res.d.sections){
          // Dawn CartDrawer knows how to consume this
          if(typeof drawer.renderContents==='function'){ drawer.renderContents(res.d); }
          else if(typeof drawer.open==='function'){ drawer.open(); }
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        } else {
          window.location.href = routes + 'cart';
        }
      })
      .catch(function(err){ atcBtn.disabled=false; alert(err.message); });
    }

    atcBtn.addEventListener('click',function(){
      if(!current || !current.available) return;
      addToCart(current.id, clampQty(qtyInput?qtyInput.value:1));
    });
    var sbAtc=document.querySelector('[data-mag-sb-atc]');
    if(sbAtc) sbAtc.addEventListener('click',function(){ if(current&&current.available) addToCart(current.id,1); });

    /* sticky mobile bar visibility */
    var bar=document.querySelector('[data-mag-stickybar]');
    if(bar && 'IntersectionObserver' in window){
      var bio=new IntersectionObserver(function(es){
        es.forEach(function(e){ bar.classList.toggle('mag-show', !e.isIntersecting && e.boundingClientRect.top<0); });
      },{threshold:0});
      bio.observe(root);
    }
  });
})();
